// extracted by mini-css-extract-plugin
export default {"favoriteTitle":"Favorite_favoriteTitle__xvKKZ","favoriteText":"Favorite_favoriteText__mUdSY","decor":"Favorite_decor__NswQK","wrapperImg":"Favorite_wrapperImg__VqOsX"};